import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom'; 
import "./nav.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Added this line


import { auth } from '../FirebaseComp/firebase'; 
import { FaUserCircle, FaCaretDown, FaBars, FaTimes } from 'react-icons/fa'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faUser, faFile, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'; 


import '@fortawesome/fontawesome-free/css/all.min.css'; // Font Awesome CSS
export const NavComp = () => {


  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const handleNavLinkClick = () => {
    setIsNavbarOpen(false); // Collapse navbar on link click
  };


   const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleDropdownClick = (event) => {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };



  const navRef = useRef(null);

  // Function to close the navbar




function closeNavbar() {
  const navbar = document.getElementById("navbar");
  if (navbar) {
    navbar.classList.remove("open");
  }
}
  const [scrolled, setScrolled] = useState(false);


  // Track scroll for sticky transparent effect
  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav 
      className={`navbar navbar-expand-lg navbar-dark sticky-top ${scrolled ? "scrolled" : ""}`}
      style={{ backgroundColor: scrolled ? "rgba(17, 24, 39, 0.95)" : "rgb(17, 24, 39)" }}
    >
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
        <img
            src="/community_logo.png" 
            alt="Community Eye Care Logo"
            height="50" // Adjust height as needed
            className="d-inline-block align-top"
          />
           
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse" id="navbarNav" ref={navRef}>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={closeNavbar}>Home</Link>
            </li>

            <li className="nav-item dropdown">
            <Link to="/aboutus" className="nav-link" onClick={closeNavbar}>About Us</Link>
            </li>

            <li className="nav-item dropdown">
            <Link to="/gallery" className="nav-link" onClick={closeNavbar}>Gallery</Link>
            </li>

            {/* Social Impact Dropdown */}
            <li className="nav-item dropdown">
              <Link 
                className="nav-link dropdown-toggle" 
                to="#" 
                id="socialImpactDropdown" 
                role="button" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
              >
                Social Impact
              </Link>
              <ul className="dropdown-menu" aria-labelledby="socialImpactDropdown">
                <li><Link to="/school-eye-health" className="dropdown-item" onClick={closeNavbar}>School Eye Camp</Link></li>
                <li><Link to="/impact3" className="dropdown-item" onClick={closeNavbar}>Eye Care Awareness</Link></li>
                <li><Link to="/impact2" className="dropdown-item" onClick={closeNavbar}>Home Service for disabled</Link></li>
                   <li><Link to="/visual-impaired-registration" className="dropdown-item" onClick={closeNavbar}>Visual Impaired Registration</Link></li>
          
              </ul>
            </li>

            <li className="nav-item">
              <Link to="/contactus" className="nav-link" onClick={closeNavbar}>Contact Us</Link>
            </li>



                    {/* Add Sign In and Sign Up buttons inside the toggle menu */}
        {!isLoggedIn && (
          <li className="auth-buttons">
            <Link to="/signin">
              <button className="navbar-btn-login" onClick={closeNavbar}>SIGN IN</button>
            </Link>
            {/* <Link to="/signup">
              <button className="navbar-btn-login" onClick={closeNavbar}>SIGN UP</button>
            </Link> */}
          </li>
        )}

          </ul>




       <div className="navbar-buttons">
        {isLoggedIn ? (
          <>
    
            <div className="user-menu-container">
              <button className="user-icon" onClick={toggleDropdown}>
                <FaUserCircle size={24} /> <FaCaretDown size={16} />
              </button>
              {showDropdown && (
                <ul className="user-dropdown" ref={dropdownRef}>
                  {/* <li>
                    <Link to="/userprofile" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/viewapplication" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> View My All Payments 
                    </Link>
                  </li>

                  <li>
                    <Link to="/viewpayment" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> Download My Payment Slips
                    </Link>
                  </li>
 */}

                  <li>
                    <button onClick={(e) => { handleLogout(); handleDropdownClick(e); }}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
                    </button>
                  </li>

                </ul>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
       </div>





        </div>
      </div>
    </nav>
  );
};